import isStudent from '../isStudent';
import isTeacher from '../isTeacher';
import isAdminOwnerSuperAdmin from '../isAdminOwnerSuperAdmin';

export default function canHaveLogbook(role = []) {
  return isStudent(role) || isTeacher(role) || isAdminOwnerSuperAdmin(role);
}
